let Api = process.env.REACT_APP_HOME_SOLUTIONS
let DocumentsApi = process.env.REACT_APP_DOCUMENTS_API
let AuthServices = process.env.REACT_APP_AUTH_SERVICES
let App = process.env.REACT_APP_HOME_SOLUTIONS_FRONTEND

export { Api, DocumentsApi, AuthServices, App }
